import { useTranslation } from 'react-i18next'

import { PeriodSelector } from '@/ui/modules/operational/components/PeriodSelector'

import { useCAAMetricsContext } from '../context/CAAMetricsContext'

export default function CAAMetricsPeriod() {
  const { t } = useTranslation()
  const { periodType, setPeriodType } = useCAAMetricsContext()

  return (
    <PeriodSelector
      value={periodType}
      onChange={(v) => setPeriodType(v)}
      options={[
        {
          label: t('caaMetrics.period.weekly'),
          value: 'WEEK'
        },
        {
          label: t('caaMetrics.period.monthly'),
          value: 'MONTH'
        },
        {
          label: t('caaMetrics.period.semesterly'),
          value: 'SEMESTER'
        },
        {
          label: t('caaMetrics.period.yearly'),
          value: 'YEAR'
        }
      ]}
    />
  )
}
